import React from "react";
import styles from "./index.module.less";

/** 对齐 spikex-ai-web GlowBackdrop — 首页 ambient 光晕（随滚动淡出） */
export default function HomePcGlowBackdrop() {
  return (
    <div className={styles.glowBackdrop} aria-hidden="true">
      <span className={styles.glowAuraRightPrimary} />
      <span className={styles.glowAuraLeftPrimary} />
      <span className={styles.glowAuraRightSecondary} />
      <span className={styles.glowAuraLeftGhost} />
    </div>
  );
}
